import type { CSSProperties, ReactNode } from 'react';

/**
 * 业务自定义线性图标公共容器（icon-map.md §3.1）：
 * 16px 视口栅格（viewBox 0 0 16 16）、stroke 1.8、round cap/join、currentColor。
 * 与 Arco 线性图标观感对齐（Arco 为 48 视口 + stroke 4，等比例迁移到 16 栅格后
 * 略加粗至 1.8 以保证小尺寸可读性）；不引入任何独立色值/渐变/实心变体。
 */
export interface BizIconProps {
  /** 渲染尺寸（px），默认 16；viewBox 恒为 16×16，放大时描边随视口等比缩放 */
  size?: number;
  className?: string;
  style?: CSSProperties;
}

interface BizIconSvgProps extends BizIconProps {
  children: ReactNode;
}

/** 统一 svg 壳：fill=none + stroke=currentColor + stroke-width 1.8 + round 端点 */
export default function BizIconSvg({ size = 16, className, style, children }: BizIconSvgProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable={false}
      className={className}
      style={style}
    >
      {children}
    </svg>
  );
}
